import angular from 'angular'

import './webregister'

// Current Sale
import './current-sale/add-customer-to-sale'

import './customer/issue-store-credit'

import { BalancesGiftCardsController } from './gift-cards/balances-gift-cards'
import { BigCommerceGiftCertsController } from './gift-cards/bigcommerce-gift-certs'
import { ActionAddNoteParkSaleController } from './current-sale/action-add-note-park-sale'
import { SelectRegisterController } from './register/select-register'

angular
  .module('webregister.controllers')
  .controller('BalancesGiftCardsController', BalancesGiftCardsController)
  .controller('BigCommerceGiftCertsController', BigCommerceGiftCertsController)
  .controller(
    'ActionAddNoteParkSaleController',
    ActionAddNoteParkSaleController
  )
  .controller('SelectRegisterController', SelectRegisterController)
